"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackAddressSelection = void 0;
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
const enums_1 = require("../../enums");
function trackAddressSelection(selectedValue, clickText) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventData: {
            eventName: enums_1.GA4EventName.ClickButton,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            click_element: enums_1.ClickElement.AddressCorrection,
            click_text: clickText,
            selected_value: selectedValue,
        },
    });
}
exports.trackAddressSelection = trackAddressSelection;
//# sourceMappingURL=trackAddressSelection.js.map